import { render } from "./AppOverlay.vue?vue&type=template&id=81734662"
import script from "./AppOverlay.vue?vue&type=script&lang=js"
export * from "./AppOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__